//@ts-ignore
import React, { Component } from "react";
import {
  MyPATTextArea,
  MyPATMathField,
  MyPATLink,
  MyPATSelect,
  MyPATPopMenu,
  SearchField,
  MyPATMultiSearch,
} from "../../../../common";
import CustomInfoIcon from "../../../../common/CustomInfoIcon";
import DeletePopUp from "../wrapperComponent/popUps";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Typography,
  createStyles,
  WithStyles,
  Button,
  Grid,
  Tooltip,
} from "@material-ui/core";
import { showMsg } from "../../../../course/actions/loaderAlert";

import {
  ReorderOutlined as ReorderIcon,
  Delete as DeleteIcon,
  SwapHoriz as ReplaceIcon,
} from "@material-ui/icons";
import contentService from "../../../services/contentService";
import ContentFormData from "../../../types/ContentFormData";
import { notesActions } from "../../../reducers/notesReducers";
import ContentFormDataError from "../../../types/ContentFormDataError";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import RadioButtons from "../wrapperComponent/wrapperCheckBox";
import { CONTENT_STATES, QUESTION_TYPE } from "../../../../../constants/comman";
import { keys } from "@material-ui/core/styles/createBreakpoints";
import MyPATBaseSection, {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../../../common/MyPATBaseSection";
import ContentData from "../../../../course/components/Types/ContentData";
import { getQuestionType, isQuestionTypeAllowed } from "../../../helper/questionTab";
// import { createNotesQuestionSchema } from '../validations/validation';

const updater = (action: string, value: number) => {
  switch (action) {
    case "INCREMENT":
      return value + 1;
    case "DECREMENT":
      return value - 1;
    default:
      return null;
  }
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flex: "grow",
    },
    tabsAlign: {
      display: "flex",
      justifyContent: "space-between",
    },
    tabsAlignaddquestion: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: "20px",
    },
    textAlignRight: {
      textAlign: "right",
    },
    addButtonAlign: {
      display: "flex",
      alignContent: "center",
      flexDirection: "row-reverse",
    },
    mb1x: {
      marginBottom: theme.spacing.unit,
    },
    // oRText: {
    //     display: 'flex',
    //     marginBottom: theme.spacing.unit,
    //     justifyContent: 'space-around'

    // },
    questionParagraph: {
      maxWidth: 535,
      "& >p": {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        margin: "0",
      },
    },
    pTagmargin: {
      "& >p:first-child": {
        margin: "0",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
      },
    },
    questionInfo: {
      border: `1px solid ${theme.palette.grey[300]}`,
      "& > div": {
        padding: `0 ${theme.spacing.unit}px`,
      },
      "& > div:first-child": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        //borderRight: `1px solid ${theme.palette.grey[300]}`
      },
    },
    questionActionBtn: {
      padding: 10,
      minWidth: "42px",
      minHeight: "42px",
      border: "1px solid #DFDFDF",
      color: theme.palette.text.secondary,
      borderRadius: 4,
    },
    buttonAlign: {
      display: "flex",
      alignContent: "center",
    },

    notesBlockTitle: {
      fontSize: 20,
      fontWeight: 400,
      paddingTop: 20,
    },
    suggestList: {
      left: "0",
      background: "#fff",
      boxShadow: "0px 0px 2px #ccc",
      padding: 0,
      zIndex: 10,
      listStyleType: "none",
      width: "100%",
    },
    addQuestionTitle: {
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "Nunito",
    },
    tabsContainer: {
      // border: 'solid 1px #E1E1E1',
      margin: "25px 0 10px 0",
      padding: "20px",
      borderRadius: "5px",
      position: "relative",
      "& label": {
        fontSize: 20,
        lineHeight: "22px",
        color: "#333333",
      },
    },
    tabsContainer2: {
      // border: 'solid 1px #E1E1E1',
      margin: "5px 0 10px 0",
      // padding: '20px',
      borderRadius: "5px",
      position: "relative",
      "& label": {
        fontSize: 20,
        lineHeight: "22px",
        color: "#333333",
      },
    },
    subHeadingSectionContainer: {
      padding: "20px 0px",
      "& > div:last-child > div": {
        marginTop: "5px"
      }
    },
    searchNotesinput: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: `0 ${theme.spacing.unit}px`,
    },
    OrDivider: {
      margin: "50px 0 25px 0",
      display: "block",
      position: "relative",
      textAlign: "center",
      height: "50px",
      zIndex: 0,
    },
    orText: {
      background: "#E0E6E7",
      height: "40px",
      width: "40px",
      borderRadius: "100%",
      fontStyle: "italic",
      fontSize: 14,
      color: "#989898",
      display: "inline-block",
      paddingTop: "8px",
      position: "absolute",
      top: "-20px",
      left: "47%",
    },
    dividerBar: {
      position: "absolute",
      left: 0,
      top: "15px",
      width: "100%",
      content: " ",
      height: "1px",
      background: "#E0E6E7",
      "z-index": "1",
    },
    textAlignCenter: {
      textAlign: "center",
    },

    addPageMore: {
      background: "#FFF !important",
      color: "#1D7DEA !important",
      width: "100",
      marginRight: 6,
      border: "1px solid #1D7DEA",
      boxSizing: "border-box",
      borderRadius: 4,
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    seachQuestionText: {
      fontSize: 16,
      fontWeight: 400,
      padding: 0,
    },
    mybtnGroup: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "60% 40%",
      "& button": {
        maxWidth: "150px",
        width: "100%",
        height: "40px",
        lineHeight: "30px",
        textAlign: "center",
        marginBottom: "-10px",
      },
    },
    containerBorder: {},
    imgSearch: {
      position: "absolute",
      left: "30px",
      top: "54px",
      "z-index": "1",
    },
    ". MuiTab-root-355": {
      fontSize: "1.25rem !important",
    },
    selectedQues: {
      paddingRight: "20px",
    },
    dialogContent: {
      padding: 0,
      maxHeight: "100%",
      marginTop: 74,
    },
    suggestItem: {
      padding: theme.spacing.unit,
      paddingBottom: theme.spacing.unit + 4,
      cursor: "pointer",
      zIndex: 11,
      "&::after": {
        clear: "both",
      },
    },
    mandatory: {
      color: "red",
    },
    ".MuiPrivateTabIndicator-colorPrimary-343": {
      backgroundColor: "none !important",
    },
    ".MuiPrivateTabIndicator-root-342": {
      display: "none !important",
    },
    chkboxLabel: {
      marginLeft: "-20px",
      fontWeight: "normal",
      color: "rgba(50, 60, 71, 1)",
      fontSize: "16px",
    },
    quesId: {
      "& a": {
        display: "initial !important",
      },
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    }
  });

enum FilterValues {
  status = "status",
  published = "PUBLISHED",
  contentType = "contentType",
  question = "question",
  MMCQ = 8,
}
enum PageKeys {
  page1 = "page1",
}

interface StudyNotesCreateProps extends WithStyles<typeof styles> {
  history: any;
  actionType: any;
  notesData: any;
  handleNotesData: any;
  pageSetForNotes: any;
  setConceptAndChapters: any;
  addTags: any;
  formData: ContentFormData;
  formDataError: ContentFormDataError;
  handleFormChange: Function;
  filterSelectedQuestion: any;
  type: any;
  showMsg: any;
  subType: any;
  pageKey: any;
  prevSubTypesState: any;
  handleFilterSelectedQuestion: Function;
  setPageInContent: any;
  removeStyleInContent: any;
  tagsList: any;
  handlePageState: any;
  tabState: any;
  inSectionContent: any;
  handleStatusTypes: Function;
  handleDeleteQuestions: Function;
  handleSectionInContent: Function;
  handleChooseFromLibrary: Function;
  checkAllPageStateKeys: Function;
  handleAddContent: Function;
  handleFilledData: Function;
  handleReplaceQuestion: Function;
  handleSearchId: Function;
  handleSearchFocus: Function;
  handleSuggestedQuestionClick: Function;
  closeSuggestedQuestions: Function;
  saveQuestionsList: Function;
  questionsList: any;
  suggestedQuestions: any;
  showSuggestedConcept: any;
}
interface StudyNotesCreateState {
  title: string;
  pageState: any;
  componentAddCounter: any;
  componenetStoreArray: any;
  isDisabled: boolean;
  touched: any;
  isAddInstruction: boolean;
  isCustomDescription: boolean;
  errorMessage: any;
  pageSetForNotes: any;
  statusTypes: any;
  deletePopUpDialog: any;
  tags: any;
  isOtherOptionsOpen: boolean;
  isFixedAttempts: boolean;
  pageArray: any;
  courses: any;
  loadingTemplates: boolean;
  templates: any;
  languages: any;
  viewDetailId: string;
  selectedTemplateId: string;
  selectedSectionId: string;
  courseName: string;
  selectQuestionDialogOpen: boolean;
  setConceptAndPages: any;
  preSelectedFilterContent: any;
  questionsList: any;
  selectedQuestionCount: any;
  isCollaspableAllowed: any;
  mathEditor: any;
  searchId: any;
  suggestedQuestions: any;
  inSectionContent: any;
  selectQuestionDialogData: {
    sectionId: string;
    subSectionId: string;
    quesCodeAllowed: number;
    noOfQuestions: number;
    replaceIndex: number;
    replaceIndexJ: number;
    content_Id: string;
    addedQuestions: any;
  };
  selectedTempQuestions: any;
  chooseLibraryKey: any;
  showSuggestedConcept: any;
  selectedTrackedQuestionIds: any;
  data: any;
  subHeading: string;
}

const initialPageState = {
  searchId: "",
  title: "",
  content_Id: "",
  customDescription: "",
  addInstruction: "",
};
const preSelectedFilterContent: any = {
  contentMenu: "all",
  goalsDriller: {},
  contentFilterData: [
    {
      filterValue: FilterValues.contentType,
      isSelected: true,
      disabled: false,
      filters: [
        {
          filterValue: FilterValues.question,
          isSelected: true,
          disabled: false,
          filters: [
            {
              filterValue: FilterValues.MMCQ,
              isSelected: true,
              filters: [],
            },
          ],
        },
      ],
    },
    {
      filterValue: FilterValues.status,
      isSelected: true,
      filters: [
        {
          filterValue: FilterValues.published,
          isSelected: true,
          filters: [],
        },
      ],
    },
  ],
};

// only for debug purpose
// const intialSelectContent =
//     [{
//         key: 'createNotes',
//         title: 'Create Notes',
//         state: 3,
//         subType: [{
//             title: 'Page 1',
//             key: 'createNotes',
//             state: 2,
//             visible: true,
//         }],
//     },
//     { key: 'conceptAndChapter', title: 'Add Concept and Chapters', state: 3, },
//     { title: 'Add Tags', key: 'tags', state: 3 }
//     ];

class StudyNotesCreate extends Component<
  StudyNotesCreateProps,
  StudyNotesCreateState
> {
  constructor(props: StudyNotesCreateProps) {
    super(props);
    // unused state should be remove further
    this.state = {
      title: this.props.notesData.title,
      pageState: { ...this.props.notesData.pageState },
      pageSetForNotes: {},
      componentAddCounter:
        Object.keys(this.props.notesData.pageState).length - 1,
      componenetStoreArray: [1],
      inSectionContent: [...this.props.prevSubTypesState],
      isDisabled: false,
      isAddInstruction: true,
      isCustomDescription: true,
      touched: {},
      setConceptAndPages: [],
      tags: [],
      searchId: "",
      errorMessage: {},
      statusTypes: {
        page1: this.props.prevSubTypesState[0].subType[0],
      },
      pageArray: [],
      questionsList: [],
      showSuggestedConcept: false,
      loadingTemplates: false,
      isOtherOptionsOpen: false,
      isFixedAttempts: false,
      deletePopUpDialog: false,
      selectedQuestionCount: 0,
      suggestedQuestions: [],
      courses: [],
      templates: [],
      languages: [],
      viewDetailId: "",
      selectedTemplateId: "",
      selectedSectionId: "",
      courseName: "",
      mathEditor: null,
      chooseLibraryKey: "",
      preSelectedFilterContent: {},
      selectQuestionDialogOpen: false,
      selectQuestionDialogData: {
        sectionId: "",
        subSectionId: "",
        quesCodeAllowed: -1,
        noOfQuestions: 0,
        replaceIndex: -1,
        replaceIndexJ: -1,
        content_Id: "",
        addedQuestions: [],
      },
      selectedTempQuestions: [],
      selectedTrackedQuestionIds: {},
      data: [],
      isCollaspableAllowed: {},
      subHeading: this.props.notesData.subHeading
    };

    this.getSearchResults = _.debounce(this.getSearchResults, 500);
  }

  componentDidMount = () => {
    const { pageKey, notesData = {} } = this.props;
    const { pageState = {} } = notesData;
    const attemptQuestionkeys = Object.keys(this.props.notesData.attempt);
    const subHeading = pageState[pageKey]['question']['subHeading'] || '';
    !subHeading && this.props.handlePageState(pageKey, 'subHeading', 'question').call(this);
    if (!attemptQuestionkeys.includes(pageKey)) {
      this.props.handleNotesData({
        attempt: {
          ...this.props.notesData.attempt,
          [pageKey]: true,
        },
      });
    }
    setTimeout(() => {
      this.props.checkAllPageStateKeys("question", pageKey, 3),
        pageState[pageKey]["question"]["searchId"] &&
          this.props.handleFilterSelectedQuestion(
            pageState[pageKey]["question"]
          );
    }, 200);
  };

  getPageNumber = (key: any): any => {
    const extractNumber = key.replace(/^\D+/g, "");
    return extractNumber;
  };

  handleCloseDialog = () => {
    this.setState({
      deletePopUpDialog: false,
    });
  };

  handleDeletePageWithPopUp = (pageKey: any) => {
    this.setState(
      {
        deletePopUpDialog: false,
      },
      () => {
        this.props.handleDeleteQuestions(pageKey);
      }
    );
  };

  setMathInstance = (mathEditor: any) => {
    this.setState({ mathEditor });
  };

  getSearchResults = (searchText: string) => {
    if(!searchText) {
      // if search string is empty then set suggestions to empty
      this.setState({
        suggestedQuestions: []
      })
      return;
    }
    const {
      notesData: { pageState },
    } = this.props;
    const filterContent: any = {
      contentFilterData: [
        {
          filterValue: "status",
          isSelected: true,
          filters: [
            {
              filterValue: CONTENT_STATES.PUBLISHED,
              isSelected: true,
              filters: [],
            },
          ],
        },
      ],
    };
    const getFilterQuestionContentIdSet = new Set(this.props.filterSelectedQuestion.map(
      (ele: any) => (ele.searchId ? ele.searchId : ele.contentId)
    ));
    contentService
      .list({ searchText: searchText.toUpperCase(), ...filterContent }, 1, 5)
      .then((list: ContentData[]) => {
        const suggestions = list.filter(suggestion => !getFilterQuestionContentIdSet.has(suggestion.contentId));
        this.setState({
          suggestedQuestions: suggestions
        })
      });
  };

  suggestionSelection = (selectedSuggestion: ContentData) => {
    
    const {
      notesData: { pageState },
      pageKey
    } = this.props;
    const type = "question";
    const contentSubTypeCode = (selectedSuggestion && +selectedSuggestion.contentSubTypeCode) || 9; // 9 is Sub Type Code for Videos
    const questionTypeAllowed = isQuestionTypeAllowed(contentSubTypeCode); 
    
    if(questionTypeAllowed) {
      if (selectedSuggestion.status === CONTENT_STATES.PUBLISHED) {
        this.props.handleFilterSelectedQuestion(selectedSuggestion);
        this.props.handleNotesData({
          pageState: {
            ...pageState,
            [pageKey]: {
              ...pageState[pageKey],
              [type]: {
                ...pageState[pageKey][type],
                ["searchId"]: selectedSuggestion.contentId,
                ["title"]: selectedSuggestion.title,
                ["content_Id"]: selectedSuggestion.content_Id,
                ["passageId"]: selectedSuggestion.passageId
              },
              ["pageContentType"]: "Question",
            },
          },
        });
        this.props.handleStatusTypes(1, pageState, pageKey);
        this.props.handleFilledData(pageKey, "question");
      } else {
        this.props.showMsg(
          "Either content Id is not valid or it is a draft content.",
          "error"
        );
      }
    } else {
      if(!questionTypeAllowed){
        
        this.props.showMsg(
          `${getQuestionType(selectedSuggestion.contentSubTypeCode.toString())} not allowed in study material`,
          "error"
        );
      }
    }
  }



  // handleOnSearch = (pageKey: any, searchText: any, type: any) => {
  //   if (!/^[Q,q]-/.test(searchText)) {
  //     this.props.showMsg(
  //       "Either content Id is not valid or it is a draft content.",
  //       "error"
  //     );
  //   } else {
  //     const {
  //       notesData: { pageState },
  //     } = this.props;
  //     const filterContent: any = {
  //       contentFilterData: [
  //         {
  //           filterValue: "status",
  //           isSelected: true,
  //           filters: [
  //             {
  //               filterValue: CONTENT_STATES.PUBLISHED,
  //               isSelected: true,
  //               filters: [],
  //             },
  //           ],
  //         },
  //       ],
  //     };
  //     const getFilterQuestionContentId = this.props.filterSelectedQuestion.map(
  //       (ele: any) => (ele.searchId ? ele.searchId : ele.contentId)
  //     );
  //     if (!getFilterQuestionContentId.includes(searchText)) {
  //       contentService
  //         .list(
  //           { searchText: searchText.toUpperCase(), ...filterContent },
  //           1,
  //           50
  //         )
  //         .then((res: any) => {
  //           if (res && res.length) {
  //             if (res[0].status === CONTENT_STATES.PUBLISHED) {
  //               this.props.handleFilterSelectedQuestion(res[0]);
  //               this.props.handleNotesData({
  //                 pageState: {
  //                   ...pageState,
  //                   [pageKey]: {
  //                     ...pageState[pageKey],
  //                     [type]: {
  //                       ...pageState[pageKey][type],
  //                       ["title"]: res[0].title,
  //                       ["content_Id"]: res[0].content_Id,
  //                     },
  //                     ["pageContentType"]: "Question",
  //                   },
  //                 },
  //               });
  //               this.props.handleStatusTypes(1, pageState, pageKey);
  //               this.props.handleFilledData(pageKey, "question");
  //             } else {
  //               this.props.showMsg(
  //                 "Either content Id is not valid or it is a draft content.",
  //                 "error"
  //               );
  //             }
  //           } else {
  //             this.props.showMsg(
  //               "Either content Id is not valid or it is a draft content.",
  //               "error"
  //             );
  //           }
  //           return Promise.resolve(res);
  //         });
  //     } else {
  //       this.props.showMsg("Question is used in another page", "error");
  //     }
  //   }
  // };

  // onKeyPress = (e: any, pageKey: string) => {
  //   const {
  //     notesData: { pageState = {}, title = "", subjects = [], tags = [] } = {},
  //   } = this.props;
  //   if (e.key == "Enter") {
  //     this.handleOnSearch(
  //       pageKey,
  //       pageState[pageKey]["question"]["searchId"],
  //       "question"
  //     );
  //   }
  // };

  handleAddQuestionComponent = (pageKeyName: any) => {
    const { classes } = this.props;
    const { chooseLibraryKey, deletePopUpDialog } = this.state;
    const { pageState = {} } = this.props.notesData;

    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={8}
          alignItems="center"
          justify="space-between"
          wrap="nowrap"
          className={classes.mb1x}
        >
          <Grid item xs="auto">
            <div key={this.getPageNumber(pageKeyName)}>
              Q{this.getPageNumber(pageKeyName)}
            </div>
          </Grid>
          <Grid item xs style={{ maxWidth: "90%" }}>
            <Grid
              container
              alignItems="center"
              wrap="nowrap"
              className={classes.questionInfo}
            >
              <Grid item xs={9}>
                <Typography
                  variant="body1"
                  classes={{ root: classes.questionParagraph }}
                  noWrap
                >
                  {
                    <span
                      className={classes.pTagmargin}
                      dangerouslySetInnerHTML={{
                        __html: pageState[pageKeyName]["question"]["title"]
                          ? pageState[pageKeyName]["question"]["title"]
                          : "",
                      }}
                    />
                  }
                </Typography>
              </Grid>
              <Grid item xs className={classes.textAlignRight}>
                <Typography variant="body1" noWrap>
                  ID:{" "}
                  <span className={classes.quesId}>
                    <MyPATLink
                      to={`/content/preview/${
                        pageState[pageKeyName]["question"]["content_Id"]
                      }question`}
                      target="_blank"
                    >
                      {pageState[pageKeyName]["question"][
                        "searchId"
                      ].toUpperCase()}
                    </MyPATLink>
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Tooltip title="Delete" placement="top">
              <Button
                variant="outlined"
                className={classes.questionActionBtn + "  btn-delete"}
                onClick={() => {
                  this.setState({
                    deletePopUpDialog: true,
                  });
                }}
              >
                {/* <DeleteIcon /> */}
                <img src="/assets/svg/myLibrary/delete-outline.svg" />
              </Button>
            </Tooltip>
          </Grid>
          <Grid item xs="auto">
            <Tooltip title="Replace" placement="right-start">
              <Button
                variant="outlined"
                className={classes.questionActionBtn + "  btn-delete"}
                onClick={() => this.props.handleReplaceQuestion(pageKeyName)}
              >
                {/* <ReplaceIcon /> */}
                <img src="/assets/svg/learn/flipQuestion.svg" />
              </Button>
            </Tooltip>
          </Grid>
          <DeletePopUp
            openDialog={deletePopUpDialog}
            handleClose={this.handleCloseDialog}
            deleteFunction={() => this.handleDeletePageWithPopUp(pageKeyName)}
          />
        </Grid>
      </div>
    );
  };

  addPageComponent = (pageKey: any): any => {
    const { pageState } = this.props.notesData;
    const { classes } = this.props;
    const { suggestedQuestions } = this.state
    const subHeading = pageState[pageKey]['question']['subHeading'] || '';
    return (
      <SectionFocusedContext.Consumer>
        {({ setSectionFocus }: SectionFocusedContextValue) => (
          <MyPATBaseSection
            sectionId={`createNotes-${pageKey}`}
            applyFocusedBorder={false}
            onFocusChange={setSectionFocus}
          >
            <div className={classes.tabsContainer}>
              <div className={classes.subHeadingSectionContainer}>
                <div>
                  <b className={classes.addQuestionTitle}>Sub Heading</b>&nbsp;<span className={classes.optionalText}>(Optional)</span>
                </div>
                <MyPATTextArea
                    name="subHeading" placeholder="Enter sub heading here" fullWidthControl
                    onChange={this.props.handlePageState(pageKey, 'subHeading', 'question')} value={subHeading}
                />
              </div>
              <div>
                <b className={classes.addQuestionTitle}>Add Question</b>
              </div>
              {!(
                pageState[pageKey] &&
                (pageState[pageKey]["question"]["title"] ||
                  pageState[pageKey]["question"]["customDescription"] ||
                  pageState[pageKey]["question"]["content_Id"])
              ) ? (
                <div className={classes.tabsContainer2}>
                  {/* <img src="../../../../assets/svg/learn/search.svg" className={classes.imgSearch}
                                            onClick={() => { this.handleOnSearch(pageKey, pageState[pageKey]['question']['searchId'], 'question') }}
                                        /> */}
                      <MyPATMultiSearch
                        options={suggestedQuestions}
                        labelKey="contentId"
                        valueKey="_id"
                        onChange={this.suggestionSelection}
                        values=""
                        isSearchAble
                        isCustomFilter
                        filtredFunction={this.getSearchResults}
                        name="search"
                        placeholderText="Search question id"
                      />
                       {/* <SearchField
                           name="search"
                           label="Search Question"
                           value={pageState[pageKey]['question']['searchId']}
                           onKeyPress={(e: any) => this.onKeyPress(e, pageKey)}
                           onFocus={() => this.props.handleSearchFocus() && setSectionFocus(true)}
                           onChange={this.props.handleSearchId(pageKey, 'searchId')}
                           onBlur={() => this.props.closeSuggestedQuestions() && setSectionFocus(false)}
                           placeholder="Search question id"
                           fullWidth
                           className={classes.searchNotesinput}
                       /> */}
                    
                  <Typography variant="caption" className={classes.OrDivider}>
                    <span className={classes.dividerBar}>
                      <b className={classes.orText}> OR </b>
                    </span>
                  </Typography>

                  <div className={classes.textAlignCenter}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.mb1x}
                      onClick={() =>
                        this.props.handleChooseFromLibrary(pageKey)
                      }
                      target="_blank"
                    >
                      Choose from Library
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  <div>{this.handleAddQuestionComponent(pageKey)}</div>
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: 16,
                      paddingTop: "20px",
                      fontWeight: "normal",
                    }}
                  >
                    Add Instruction{" "}
                    {
                      <CustomInfoIcon
                        infoDialogContentType="Add alternate answer"
                        isInfoIcon={true}
                        isRightArrow={false}
                        isCenterArrow={true}
                        knowMoreAbout={false}
                        showMore={false}
                        //isClickRequired={false}
                        dialogTitle="Add instruction"
                        imageURL="/assets/svg/learn/instructions.svg"
                        dialogPara="This is the set of instructions which will be shown to the student at the time of attempting this question. This is an optional field"
                        details="Click to know more"
                        toolTipDirection="top"
                      />
                    }
                    {/* <span className={classes.mandatory}>*</span> */}
                  </Typography>
                  <MyPATMathField
                    variant="textArea"
                    editorProps={{
                      externalToolbarId: "box",
                      name: `addInstruction`,
                      handleChange: this.props.handlePageState(
                        pageKey,
                        "addInstruction",
                        "question"
                      ),
                      setInstance: this.setMathInstance,
                      editorId: pageKey,
                      value:
                        pageState[pageKey]["question"]["addInstruction"] || "",
                    }}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontSize: 16,
                        paddingTop: "20px",
                        fontWeight: "normal",
                      }}
                    >
                      Attempt Question
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "2px",
                        alignContent: "flex-start",
                      }}
                    >
                      <RadioButtons pagekey={pageKey} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </MyPATBaseSection>
        )}
      </SectionFocusedContext.Consumer>
    );
  };

  render = () => {
    const { errorMessage } = this.state;
    const {
      classes,
      type,
      notesData: { pageState = {}, title = "", subjects = [], tags = [] } = {},
    } = this.props;
    return (
      <>
        {/* <div>
                    {errorMessage['title']? errorMessage['title']: ''}
                    </div> */}
        {this.addPageComponent(this.props.pageKey)}
        <div className={classes.addButtonAlign} />
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    prevSubTypesState: _.get(state, "studyNotedReducers", []),
    tagsList: _.get(state, "mylibraryData.contentTags.list", []),
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPageInContent: notesActions.addSubTypes,
      removeStyleInContent: notesActions.removeSubTypes,
      showMsg: showMsg,
      setConceptAndChapters: notesActions.addConceptAndChapter,
      setTags: notesActions.addExtraTags,
    },
    dispatch
  );
  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(styles)(StudyNotesCreate));
